"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fourteen/sections/startSliderSection.tsx */

import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type StartSliderSectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "Hydrafacial Starting from ₹999 Limited Offer" | "Flat 25% Off on Anti-Aging Treatments" | "Offer : 15% Discount on First Appointment" | "Summer Skin Care Offers Available Now" */
    h30Text: ReactNode;
    /** Detected variants: "services-slide" */
    className?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};
export type HomeFourteenStartSliderSectionGeneratedProps = {
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: StartSliderSectionServicesSlidesItem) => Partial<ComponentProps<"h3">>);
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    /** Default: "left" */
    sectionDiv0DivDataDirection?: string;
    /** Default: "slow" */
    sectionDiv0DivDataSpeed?: string;
    startSliderSectionServicesSlides: StartSliderSectionServicesSlidesItem[];
    startSliderSectionServicesSlidesItemWrapper?: (item: StartSliderSectionServicesSlidesItem, content: ReactNode) => ReactNode;
    startSliderSectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    startSliderSectionServicesSlidesH3Visible?: boolean;
    startSliderSectionServicesSlidesH3Renderer?: (item: StartSliderSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    startSliderSectionServicesSlidesH3Props?: Partial<ComponentProps<"h3">> | ((item: StartSliderSectionServicesSlidesItem) => Partial<ComponentProps<"h3">>);
};

const HomeFourteenStartSliderSectionGenerated: FC<HomeFourteenStartSliderSectionGeneratedProps> = ({
    sectionDataWowDuration = "1s",
    sectionDiv0DivDataDirection = "left",
    sectionDiv0DivDataSpeed = "slow",
    divH30H3Props,
    startSliderSectionServicesSlides,
    startSliderSectionServicesSlidesItemWrapper,
    startSliderSectionServicesSlidesRenderer,
    startSliderSectionServicesSlidesH3Visible,
    startSliderSectionServicesSlidesH3Renderer,
    startSliderSectionServicesSlidesH3Props,
}) => {
    return (
        <section className="slider-section-fourteen wow fadeInUp" data-wow-duration={sectionDataWowDuration}>
            <div className="horizontal-slide slide-fourteen d-flex" data-direction={sectionDiv0DivDataDirection} data-speed={sectionDiv0DivDataSpeed}>
                <div className="slide-list d-flex gap-4">
                    {renderCollectionNode(
                        startSliderSectionServicesSlides,
                        (item: StartSliderSectionServicesSlidesItem) => (
                            <div className={item.className ?? "services-slide"} key={item.key}>
                                {renderItemNode(startSliderSectionServicesSlidesH3Visible, startSliderSectionServicesSlidesH3Renderer, item, (
                                    <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof startSliderSectionServicesSlidesH3Props === "function" ? startSliderSectionServicesSlidesH3Props(item) : (startSliderSectionServicesSlidesH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>{item.h30Text}</h3>
                                ))}
                            </div>
                        ),
                        startSliderSectionServicesSlidesItemWrapper,
                        startSliderSectionServicesSlidesRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeFourteenStartSliderSectionGenerated;
